import gql from 'graphql-tag'
import { PRODUCT_MAIN_VARIANT_BASE_FRAGMENT } from '~/graphql/gql/product/fragments/productMainVariantBaseFragment'

export const GET_PRODUCT_XSELL_PRODUCT = gql`
  query getXsellProductsUpSell(
    $variantId: ID!
    $userId: String!
    $provider: XsellRecommendedProductsProvider!
    $limit: Int = 32
    $version: String = null
  ) {
    getXsellProducts(
      variantId: $variantId
      query: {
        provider: $provider
        userId: $userId
        limit: $limit
        version: $version
      }
    ) {
      __typename
      products {
        __typename
        ... on XsellBaseProduct {
          groupsIds
          __typename
        }

        ... on XsellTipProduct {
          advantagesLabels
          advantagesParameters
          parameters {
            key
            title
            value
            order
            visible
            url
            description
            measure {
              measureId
              title
              description
            }
            groupId
          }
        }

        ... on XsellProduct {
          __typename
          id
          product {
            id
            title
            mainMenuUrlKey
            mainCategoryUrlKey
            rank {
              rank
              count
            }
            isAdultOnly
            productTypeId
            mainVariant {
              mediaId
              ...mainVariant
            }
            id
            title
          }
        }
      }
      groups {
        id
        name
      }
    }
  }

  ${PRODUCT_MAIN_VARIANT_BASE_FRAGMENT}
`

export const GET_PRODUCT_PARAMS_XSELL = gql`
  query getProductVariantsByIdsXSellParams($id: ID!) {
    getProductVariantsByIds(ids: [$id]) {
      id
      isAdultOnly
      mainVariant {
        id
        mediaId
        parameters {
          key
          order
          title
          value
          paramValueId
          visible
          url
          description
          measure {
            description
            measureId
            title
          }
        }
      }
    }
  }
`
